<template>
    <div>
        <div class="quickFormItem">
            <div>
                <el-form ref="ruleForm" :model="formItem" :rules="formRules">
                    <el-form-item v-for="(domain, index) in formItem.info" :key="domain.instant_app_id" :style="{marginBottom: '0'}">
                        <QucikItem ref="QucikItem" :key="domain.instant_app_id" :domain="domain" :err_ids="err_ids" :index="index" :page_select_options="page_select_options" @changestatus="handleChangeStatus"/>
                    </el-form-item>

                    <el-form-item prop="is_check_quick">
                        <el-button v-if="!formItem.is_check_quick" type="primary"
                                   @click="submitModal" :loading="formLoading"
                                   :disabled="list.length === 0"
                                   class="mt10"
                        >快应用验证</el-button>
                        <el-button v-else type="primary" size="mini" style="width: 120px;" class="mt10">已验证</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>

<!--            <p v-if="is_show_err" class="text-color-error font12px">请核实快应用信息</p>-->
        </div>
    </div>

</template>
<script>
import API from "@/api/marketManage/oppoBatch";
import { errorPlanModal } from '../modal/index.js'
import Tips from "@/views/marketingManagement/oppo/components/tips.vue";
import QucikItem from './quickItem.vue'
export default {
    name: 'quickFormItem',
    components: { QucikItem },
    props:{
      list: {
          type: Array,
          default: () => []
      },
        recourse: {
            type: Object,  // 第一步依赖参数
            default: () => {}
        }
    },
    watch: {
        'list': {
            handler(newVal) {
                let res_cacah_list = this.formItem.info.map(item=>item.instant_app_id)
                if(newVal.length == 0) {
                    this.formItem.info = []
                }
                newVal.forEach((item)=>{
                    if(!res_cacah_list.includes(item.app_id)) {
                        // this.fetch_quick_app_info(item.app_id)
                        let res_page_type = this.page_select_options.length !== 0 ? this.page_select_options[0].value : ''
                        this.formItem.info.push({
                            instant_app_name: item.app_name,
                            instant_app_id:item.app_id,
                            instant_app_package:item.package_name,
                            instant_app_url: '',  //完整直达链接  hap://game/com.fl.adragrace.net.nearme.gamecenter
                            // page_url_info:{
                            //     page_type: res_page_type,  // 自定义与下拉
                            //     page_url: '',  // 打底网页
                            //     page_id: '',
                            // },
                            page_type: res_page_type,  // 自定义与下拉
                            page_url: '',  // 打底网页
                            page_id: '',

                            curIndex: 0,
                        })
                    }else{
                        let include_list = newVal.map(itemc=>itemc.app_id)
                        let cur_del_index = this.formItem.info.findIndex(itemc=>!include_list.includes(itemc.instant_app_id))
                        if(cur_del_index !== -1) {
                            this.formItem.info.splice(cur_del_index, 1)
                        }
                    }
                })
                this.formItem.is_check_quick = false
                this.$emit('quickCheck', this.formItem.is_check_quick)
                this.is_show_err = false
                this.formLoading = false
            },
            immediate: true
        },
    },
    data() {
        const validatePlan = (rule, value, callback) => {
            if(value) {
                callback();
            }else{
                callback(new Error('请核实快应用信息'));
            }
        };
        return {
            formLoading: false,  //12-快应用 11-应用
            formItem: {
                is_check_quick: false,
              info: [
                  // {
                  //     instant_app_url: '',  //完整直达链接
                  //     page_url_info:[{
                  //         recourse: '',  // 自定义与下拉
                  //         page_url: '',  // 打底网页
                  //         page_id: '',
                  //     }],
                  //     curIndex: 1,
                  // },{
                  //     instant_app_url: '',  //完整直达链接
                  //     page_url_info:[{
                  //         page_type: '',  // 自定义与下拉
                  //         page_url: '',  // 打底网页
                  //         page_id: '',
                  //     }],
                  //     curIndex: 1,
                  // }
              ]
            },
            formRules:{
                is_check_quick: { validator: validatePlan, trigger: 'clear' },
            },
            page_select_options:[],
            is_show_err: false,
            err_ids:[]
        }
    },
    mounted() {
        // this.fet_quick_list()
    },
    methods: {
        clearQuickForm() {
            // this.$refs.ruleForm.validate();

            this.formItem.is_check_quick= false
            this.formItem.info = []
            this.fet_quick_list()
        },
        async handleValidate(valiUrl) {
            await this.$refs.ruleForm.validate();
            return this.validateFn(valiUrl)
            // if(!this.formItem.is_check_quick) {
            //     this.is_show_err = true
            // }else{
            //     this.is_show_err = false
            // }

        },
        // 获取表单数据
        async validateFn(valiUrl) {
            try {
                const list = await Promise.all(this.$refs.QucikItem.map(v=> {
                    return v.validateFn(valiUrl)
                }));
                let res_instant_app = list.map(item=>({
                    instant_app_id:item.instant_app_id,
                    instant_app_name: item.instant_app_name,
                    instant_app_package: item.instant_app_package,
                    instant_app_url:item.instant_app_url,
                    page_url_info:item.page_url_info
                }));
                return Promise.resolve(res_instant_app)
            } catch (error) {
                return Promise.reject('false')
            }

        },
        // 获取到底网页 this.formItem.target_account && this.formItem.target_account.length !=0 ? this.formItem.target_account[0] : '', //目标账户id
        fet_quick_list() {
            API.getAdgroupList({
                company_id: this.recourse.target_account && this.recourse.target_account.length !=0 ? this.recourse.target_account[0] : '',
                plan_id:this.recourse.plan_id,
                task_id:this.recourse.taskId,
                extension_type: 3,

            }).then(res=>{
                this.page_select_options = res.data
                this.$emit('quickInfo')
            },err=>{
                this.$message.error(err.info)
                this.$emit('quickInfo')
            })
        },
        // 快应用验证信息  this.formItem.target_account && this.formItem.target_account.length !=0 ? this.formItem.target_account[0] : '', //目标账户id
        fetch_quick_app_url(instant_app) {
            this.isCheckedQuickLoading = true
            API.getInstantUrl({
                company_id: this.recourse.target_account && this.recourse.target_account.length !=0 ? this.recourse.target_account[0] : '',
                instant_app:instant_app
            }).then(res=>{
                this.isCheckedQuick = true
                this.isCheckedQuickLoading = false

                this.quickInfo = res.data[0]
                this.formItem.is_check_quick = true  //验证通过
                this.err_ids = []
                this.$emit('jtClear')

                this.$refs.ruleForm.clearValidate()
                this.$emit('quickCheck', this.formItem.is_check_quick)
            },err=>{
                const {vm} = errorPlanModal({
                    props:{
                        title: err.info,
                        list: err.data
                    },
                    cbs:{
                        confirm:() => {
                            this.$emit('jtClear')
                            let select_plan_options = err.data
                            this.err_ids = err.data.map(item=>item.id)
                            if(select_plan_options.length !== 0) {
                                select_plan_options.forEach((item)=>{
                                    let msg = item.err_msg.length !== 0 ? item.err_msg.join('<br/>') : '暂无错误信息';
                                    // this.$refs.planJtSelect.setTagState(item.id.toString(), [Tips,{ msg:`<div>${msg}</div>` }])
                                    this.$emit('jtError', {id: item.id.toString(), tips: [Tips,{ msg:`${msg}` }]})
                                })
                            }
                            vm.close()
                        }
                    }
                });
            }).finally(()=>{
                this.$emit('quickInfo', instant_app)
                this.formLoading = false
            })
        },
        // 快应用验证
        submitModal() {
            if(this.list.length === 0) {
                this.$message.error('请选择投放产品')
                return
            }
            this.formLoading = true
            this.validateFn().then(res=>{
                this.fetch_quick_app_url(res)
            }, err=>{
                this.formLoading = false
            })

        },
        handleChangeStatus() {
            this.formItem.is_check_quick= false
        }
    }
}
</script>
<style scoped lang="scss">
.quickFormItem{

    //border: 1px solid #dadada;
    //border-bottom: none;
    width: 600px;


}
</style>

